module.exports = {
  wildcard: true,
  delimiter: ':',
  newListener: false,
  maxListeners: process.env.BLAZE_MAX_EVENT_LISTENERS || 20
};
